import deepmerge from 'deepmerge';
import { defaults } from 'src/environments/defaults';
import { EnvironmentConfig } from 'src/environments/type';
import { globalVariables } from 'src/app/core/settings/global-variables.setting';

export const tenantConfiguration: EnvironmentConfig = deepmerge(defaults, {
  tenant: 'ceremony',
});
